import { HsHypersceneConstants } from '../../math-new/constants/hyperscene-constants.global';
import { HsIndexedGeometryData } from '../geometry-utils/indexed-geometry-data.class';

export function hsGenerateTorusGeometryData(
  radius: number,
  innerRadius: number,
  segments: number = 8,
  quality: number = 32
): HsIndexedGeometryData {
  const vertices: number[] = [];
  const normals: number[] = [];
  const indices: number[] = [];
  for (let j: number = 0; j <= segments; j++) {
    const theta: number = (j / segments) * HsHypersceneConstants.PI_MUL_2;
    const y: number = innerRadius * Math.sin(theta);
    for (let i: number = 0; i <= quality; i++) {
      const phi: number = (i / quality) * HsHypersceneConstants.PI_MUL_2;
      const x: number = (radius + innerRadius * Math.cos(theta)) * Math.cos(phi);
      const z: number = (radius + innerRadius * Math.cos(theta)) * Math.sin(phi);
      vertices.push(x, y, z);
      normals.push(Math.cos(theta) * Math.cos(phi), Math.sin(theta), Math.cos(theta) * Math.sin(phi));
    }
  }
  for (let i: number = 0; i < segments; i++) {
    for (let j: number = 0; j < quality; j++) {
      const first: number = i * (quality + 1) + j;
      const second: number = first + quality + 1;
      indices.push(second, first, first + 1, second + 1, second, first + 1);
    }
  }
  return new HsIndexedGeometryData(vertices, normals, indices);
}
